import React, { useState, useContext, useEffect, useTransition } from 'react';
import PopupWithForm from '../PopupWithForm/PopupWithForm';
import { CurrentUserContext } from '../../context/CurrentUserContext';
import MainApi from '../../utils/API/MainApi.js';
import { useTranslation } from '../../utils/hooks/translateHook.js';

function ChangePasswordPopup({ isOpen, onClose }) {
  const { currentUser } = useContext(CurrentUserContext);
  const t = useTranslation();

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    setFormData({
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
    setFormErrors({});
    setIsButtonEnabled(false);
    setSubmitError('');
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: value ? false : 'Required field',
    }));
  };

  useEffect(() => {
    const { oldPassword, newPassword, confirmPassword } = formData;

    const allFilled = oldPassword && newPassword && confirmPassword;
    const passwordsMatch = newPassword === confirmPassword;

    setFormErrors((prev) => ({
      ...prev,
      confirmPassword: passwordsMatch ? false : "Passwords do not match",
    }));

    setIsButtonEnabled(allFilled && passwordsMatch);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSubmitError('');

    const token = localStorage.getItem('token');
    const payload = {
      newPassword: formData.newPassword,
      oldPassword: formData.oldPassword,
    };

    try {
      const response = await MainApi.updateProfile(currentUser._id, payload, token);
      if (response.user) {
        onClose();
      }
    } catch (err) {
      console.error('Password update failed:', err);
      setSubmitError(err.message || 'Failed to change password.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PopupWithForm
      title={t('changePassword')}
      name="changepassword"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      buttonText={isLoading ? t('updating') : t('saveChanges')}
      buttonClassName="change-password"
      closeButtonClassName="change-password-close"
      isButtonEnabled={isButtonEnabled}
      isLoggedIn={true}
    >
      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('oldPassword')}</p>
        <input className="popup__input" name="oldPassword" type="password" placeholder={t('enterCurrentPass')}
          value={formData.oldPassword} onChange={handleChange}
          required />
        <span className="popup__input-error">{formErrors.oldPassword}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('newPassword')}</p>
        <input className="popup__input" name="newPassword" type="password" placeholder={t('enterNewPass')}
          value={formData.newPassword} onChange={handleChange}
          required />
        <span className="popup__input-error">{formErrors.newPassword}</span>
      </label>

      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('confirmNewPassword')}</p>
        <input className="popup__input" name="confirmPassword" type="password" placeholder={t('confirmNewPass')}
          value={formData.confirmPassword} onChange={handleChange}
          required />
        <span className="popup__input-error">{formErrors.confirmPassword}</span>
      </label>

      {submitError && <p className="popup__input-error" style={{ color: 'red' }}>{submitError}</p>}
    </PopupWithForm>
  );
}

export default ChangePasswordPopup;
